import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';
import { OrderStatus } from './enums/OrderStatus';
import { Address } from './Address';
import { PaymentMethod } from './enums/PaymentMethod';

export class Order {
  id: number;

  @Expose({ name: 'invoice_no' })
  invoiceNumber: string;

  status: OrderStatus;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  total: string;

  @Expose({ name: 'total_bv' })
  totalPv: string;

  @Type(() => Address)
  billing: Address;

  @Type(() => Address)
  shipping: Address;

  @Expose({ name: 'payment_method' })
  paymentMethod: PaymentMethod;

  @Type(() => OrderProduct)
  products: OrderProduct[];

  constructor(
    id: number,
    invoiceNumber: string,
    status: OrderStatus,
    dateCreated: Date,
    total: string,
    totalPv: string,
    billing: Address,
    shipping: Address,
    paymentMethod: PaymentMethod,
    products: OrderProduct[]
  ) {
    this.id = id;
    this.invoiceNumber = invoiceNumber;
    this.status = status;
    this.dateCreated = dateCreated;
    this.total = total;
    this.totalPv = totalPv;
    this.billing = billing;
    this.shipping = shipping;
    this.paymentMethod = paymentMethod;
    this.products = products;
  }

  static fromJson(json: Record<string, any>): Order {
    return plainToInstance(Order, json, { enableCircularCheck: true });
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class OrderProduct {
  sku: string;

  name: string;

  price: string;

  bv: string;

  expiry?: number;

  image?: string;

  constructor(
    sku: string,
    name: string,
    price: string,
    bv: string,
    expiry?: number,
    image?: string
  ) {
    this.sku = sku;
    this.name = name;
    this.price = price;
    this.bv = bv;
    this.expiry = expiry;
    this.image = image;
  }

  static fromJson(json: Record<string, any>): OrderProduct {
    return plainToInstance(OrderProduct, json, { enableCircularCheck: true });
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
